export const ADD_DRIVER_JSON_MAP = {
  firstName: 'First Name',
  lastName: 'Last Name',
  policyNumber: 'Policy Number',
  phoneNumber: 'Phone Number',
  streetAddress: 'Street Address',
  zipCode: 'Zip Code',
  emailAddress: 'Email Address',
  additionalHousehold: {
    firstName: 'Additional Member First Name',
    lastName: 'Additional Member Last Name',
    dateOfBirth: 'Additional Member Date Of Birth',
    maritalStatus: 'Additional Member Marital Status',
    gender: 'Additional Member Gender',
    relationship: 'Additional Member Relationship to the Policyholder',
    effectDate: 'What date would you like this change to go into effect?'
  }
}
